import React, { PureComponent } from "react";
import PopOverLimit from './PopOverLimit.jsx';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper.js';

class PopUpCuentas extends PureComponent {

    render() {
        const { limiteGlobalTotalFormato, limiteGlobalSinAsignarFormato, nodoCuentas, descripcion } = this.props;

        return (
            <div className="dropdown">
                <a className="dropdown-toggle btn-link" data-toggle="dropdown"><h6>Ver los limites actuales</h6></a>
                <ul className="dropdown-menu pull-right" style={{ "right": "560px", "top": "-10px", "width": "400px" }}>
                    <div className="row">
                        <div className="col-xs-11">
                            <h4>Distribución actual de límites</h4>
                        </div>
                        <div className="col-xs-1">
                            <a><span className="glyphicon glyphicon-remove" style={{ "right": "10px" }} /></a>
                        </div>
                    </div>
                    <li className="list-group-item">
                        <div className="row">
                            <div className="col-xs-8">
                                <label className="label-primary">Límite global total para: {descripcion}</label>
                            </div>
                            <div className="col-xs-4">
                                <label className="label-secondary">${limiteGlobalTotalFormato}</label>
                            </div>
                        </div>
                    </li>
                    <div>
                        {nodoCuentas}
                    </div>
                    <li className="list-group-item">
                        <div className="row">
                            <div className="col-xs-8">
                                <label className="label-primary">Límite global sin asignar:</label>
                            </div>
                            <div className="col-xs-4">
                                <label className="label-secondary">${limiteGlobalSinAsignarFormato}</label>
                            </div>
                        </div>
                    </li>
                    <h6>Puede definir ahora un límite inconsistente con esta distribución y hacer luego las correcciones necesarias con la opción "Distribuir límites".</h6>
                </ul>
            </div>
        );

    }
}

class SelectPurchaseLimit extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            LimiteCompraId: props.Cuenta.LimiteCompraId
        }
    }

    render() {

        const { Validaciones, ValidarPantalla, GET_LIMITE_COMPRA, Cuenta, tarjetas, seleccionarCombo } = this.props;
        const { empresas, cuentas, novedadesCuentas } = tarjetas;
        const empresaSeleccionada = empresas.find((empresa) => empresa.seleccionada == true);

        let limiteGlobalSinAsignar = empresaSeleccionada.LimiteCompra;
        let limiteGlobalTotalFormato = GlobalHelper.ConvertirNumeroSinDecimales(empresaSeleccionada.LimiteCompra);
        let limiteGlobalSinAsignarFormato;
        let limiteNovedad;

        const optionLimites = GET_LIMITE_COMPRA.map((limiteCompra, index) => {
            return (
                <option key={"limite-compra-opt" + index} value={limiteCompra.Id} data-codigo={limiteCompra.Codigo} data-valor={limiteCompra.Valor}>
                    {GlobalHelper.ConvertirNumeroMilesMillones(limiteCompra.Valor)}
                </option>
            );
        });

        const nodoCuentas = cuentas.filter((c1) => (c1.EmpresaId || c1.EmpresaVisaId) == empresaSeleccionada.Id).map((cuenta, index) => {

            let novedad = novedadesCuentas.find(x => x.CuentaTarjetaId == cuenta.Id);

            if (novedad) {
                let limiteCompra = GET_LIMITE_COMPRA.find(x => x.Id == novedad.ValorNovedad);
                if (!limiteCompra) {
                    limiteCompra = GET_LIMITE_COMPRA.find(x => x.Valor == novedad.ValorNovedad);
                    limiteNovedad = GlobalHelper.ConvertirNumeroSinDecimales(limiteCompra.Valor);
                    limiteGlobalSinAsignar -= limiteCompra.Valor;
                }
                else {
                    limiteNovedad = GlobalHelper.ConvertirNumeroSinDecimales(limiteCompra.Valor);
                    limiteGlobalSinAsignar -= limiteCompra.Valor;
                }

            }
            else {
                limiteNovedad = cuenta.valorFormato;
                limiteGlobalSinAsignar -= cuenta.Valor
            }

            return <PopOverLimit key={"pop-over-limit-" + index} Denominacion={cuenta.Descripcion} LimiteCompra={limiteNovedad} />;

        });

        limiteGlobalSinAsignarFormato = GlobalHelper.ConvertirNumeroSinDecimales(limiteGlobalSinAsignar);
        let mensajeErrorLimite = null;

        if (ValidarPantalla == true) {
            if (Validaciones.LimiteCompraSeleccionado == false) {
                mensajeErrorLimite = <label className="error">Debe seleccionar un límite de compra.</label>;
            }
        }

        return (
            <div className="bottom-separator-xs">

                <div className="row">
                    <div className="col-xs-12">
                        <label className="label-primary">Límite de Compra</label>
                    </div>
                </div>

                <div className="row bottom-separator-xs">
                    <div className="col-xs-1 width-0">
                        <p>$</p>
                    </div>
                    <div className="col-xs-4">
                        <select className="form-control default-select" value={Cuenta.LimiteCompraId}
                            onChange={(event) => {
                                let index = event.target.selectedIndex;
                                let optionActual = event.target.options[index];
                                let codigo = optionActual.dataset.codigo;
                                let valor = parseInt(optionActual.dataset.valor);

                                seleccionarCombo(event.target.value, "LIMITE-COMPRA", codigo, valor);
                            }}>
                            <option value="0">Seleccione...</option>
                            {optionLimites}
                        </select>
                        {mensajeErrorLimite}
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-5">
                        {(Cuenta.LimiteCompraValor > empresaSeleccionada.LimiteCompra) ?
                            <div>
                                <span className="glyphicon glyphicon-exclamation-sign" style={{ "color": "red" }}></span>
                                El valor que ingresó eleva la sumatoria de los límites de las cuentas por sobre el de la empresa.
                        Por favor, al finalizar la creación de la cuenta recuerde usar la opción
                        "Distribuir límites" para solucionarlo
                    </div> : null
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <PopUpCuentas
                            limiteGlobalSinAsignarFormato={limiteGlobalSinAsignarFormato}
                            limiteGlobalTotalFormato={limiteGlobalTotalFormato}
                            descripcion={empresaSeleccionada.Descripcion}
                            nodoCuentas={nodoCuentas}
                        />
                    </div>
                </div>

            </div>
        );
    }
}

export default SelectPurchaseLimit;